import { matchesActions } from "../../store/matches/actions";
import { put, call, takeEvery } from "redux-saga/effects";
import { getBetsByMatchRequest, searchMatchesRequest } from "../../api/matches";
import {
  GET_BETS_BY_MATCH_REQUEST,
  SEARCH_MATCHES_REQUEST,
} from "../../constants/matches";

function* searchMatchesRequestSaga(action: any): any {
  try {
    const matches = yield call(searchMatchesRequest, action.payload);
    yield put(matchesActions.searchMatchesSuccessAction(matches));
  } catch (e: any) {
    yield put(matchesActions.searchMatchesFailureAction(e));
  }
}

function* getBetsByMatchRequestSaga(action: any): any {
  try {
    yield put(matchesActions.clearCurrentMatchBets());
    const result = yield call(getBetsByMatchRequest, action.payload);
    if (result.bets.length === 0) {
      yield put(matchesActions.getBetsByMatch0BetsAction());
    } else {
      yield put(matchesActions.getBetsByMatchSuccessAction(result.bets));
    }
  } catch (e: any) {
    yield matchesActions.getBetsByMatchFailureAction(e);
  }
}

function* matchesSaga() {
  yield takeEvery(SEARCH_MATCHES_REQUEST, searchMatchesRequestSaga);
  yield takeEvery(GET_BETS_BY_MATCH_REQUEST, getBetsByMatchRequestSaga);
}

export default matchesSaga;
